module.exports = __webpack_public_path__ + "images/category_lp/watch/omega/store_images/1@2x_b5a258175837b6078afc5c70d7ddd99e.png";